import { defineStore } from 'pinia';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase';

export const useServiceStore = defineStore('service', {
  state: () => ({
    services: {},
    unsubs: []
  }),
  persist: { paths: ['services'] },
  actions: {
    upsert({ id, value }) {
      this.services = { ...this.services, [id]: value };
    },
    remove(id) {
      const services = { ...this.services };
      delete services[id];
      this.services = services;
    },
    clearUnsubs() {
      for (const unsub of this.unsubs) {
        if (typeof unsub === 'function') unsub();
      }
      this.unsubs = [];
    },
    clear() {
      this.clearUnsubs();
      this.services = {};
    },
    registerSnapshot() {
      this.clearUnsubs();
      let snapshotQuery = collection(firestore, 'services');
      const unsub = onSnapshot(
        snapshotQuery,
        (snapshot) => {
          snapshot.docChanges().forEach((element) => {
            const elementData = { ...element.doc.data() };
            elementData.id = element.doc.id;
            if (element.type === 'added' || element.type === 'modified') {
              this.upsert({ id: element.doc.id, value: elementData });
            } else {
              this.remove(element.doc.id);
            }
          });
        },
        (error) => {
          console.error('Service - Error registering snapshot', error);
        }
      );
      this.unsubs.push(unsub);
    }
  }
});
